import { render, staticRenderFns } from "./StickerMessage.vue?vue&type=template&id=6b3a9ab8&scoped=true&"
import script from "./StickerMessage.vue?vue&type=script&lang=js&"
export * from "./StickerMessage.vue?vue&type=script&lang=js&"
import style0 from "./StickerMessage.vue?vue&type=style&index=0&id=6b3a9ab8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a9ab8",
  null
  
)

export default component.exports